<template>
  <v-data-table v-bind="$attrs"
                v-on="$listeners"
                :headers="headers"
                :items="patients.filter((p) => { return p.created_at > '2024-05-01 00:00:00'; })"
                :value="selected"></v-data-table>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("patientsN", ["selected"]),

    headers () {
      return [
        {
          text: "#",
          value: "id",
        },
        {
          text: "Nom",
          value: "last_name"
        },
        {
          text: "Prénom",
          value: "first_name"
        }
      ];
    }
  },

  props: {
    patients: {
      required: true,
      type: Array
    }
  }
};
</script>
